import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PlanType } from "sdk/types";
import { useTrialDiscount } from "~/MemberApp/hooks";
import { DiscountLine } from "./DiscountLine";

interface Props {
  type: PlanType;
}

export const TrialDiscount: FC<Props> = ({ type }) => {
  const { t } = useTranslation();
  const trialDiscount = useTrialDiscount();
  const discountAmount =
    (trialDiscount &&
      trialDiscount[type] &&
      trialDiscount[type].discountedAmount) ||
    "";

  return (
    <DiscountLine
      description={t("planPayment.extend.discount.label")}
      discountAmount={discountAmount}
    />
  );
};
